export const districtDetailScreenshots = [
  {
    id: "210",
    srcName: "Eastern District.png",
  },
  {
    id: "201",
    srcName: "Kowloon District.png",
  },
  {
    id: "204",
    srcName: "Kwai Tsing District.png",
  },
  {
    id: "214",
    srcName: "Kwun Tong District.png",
  },
  {
    id: "205",
    srcName: "North District.png",
  },
  {
    id: "215",
    srcName: "Sai Kung District.png",
  },
  {
    id: "217",
    srcName: "Sha Tin District.png",
  },
  {
    id: "213",
    srcName: "Sham Shui Po District.png",
  },
  {
    id: "206",
    srcName: "Tai Po District.png",
  },
  {
    id: "207",
    srcName: "Tsuen Wan District.png",
  },
  {
    id: "218",
    srcName: "Tuen Mun District.png",
  },
  {
    id: "212",
    srcName: "Wan Chai District.png",
  },
  {
    id: "203",
    srcName: "Yau Tsim Mong District.png",
  },
  {
    id: "208",
    srcName: "Yuen Long District.png",
  },
];
